import { render, staticRenderFns } from "./InspectionColumn.vue?vue&type=template&id=19efce52&scoped=true&"
import script from "./InspectionColumn.vue?vue&type=script&lang=ts&"
export * from "./InspectionColumn.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionColumn.vue?vue&type=style&index=0&id=19efce52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19efce52",
  null
  
)

export default component.exports